import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const ConfirmAction = ({ trigger, title, description, confirmLabel, onConfirm, testId }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
    <AlertDialogContent className="bg-[#121314] border-white/10 text-white rounded-none" data-testid={`${testId}-dialog`}>
      <AlertDialogHeader>
        <AlertDialogTitle className="dz-heading text-2xl uppercase font-black">{title}</AlertDialogTitle>
        <AlertDialogDescription className="text-zinc-400">{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="rounded-none bg-transparent border-white/15 text-zinc-300" data-testid={`${testId}-cancel`}>Cancelar</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="rounded-none bg-[#c81e1e] hover:bg-[#a51818] text-white" data-testid={`${testId}-confirm`}>
          {confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
